import React from 'react';
import TermsAndConditions from '../components/Terms-Policy-Refund/Refund';
import CenteredTitleSection from '../components/Terms-Policy-Refund/CenteredTitleSection';

const Terms = () => {
  return (
    <>
    <CenteredTitleSection
        title="Teacher Training"
        subtitle="Last Updated: 27/12/2023"
      />
      <TermsAndConditions />
    </>
  );
};

export default Terms;
